import Vue from 'vue'
import Vuex from 'vuex'
import appModule from './modules/app-module'
import authModule from './modules/auth-module'
import subscriptionModule from './modules/subscription-module'
import paymentMethodModule from './modules/payment-method-module'
import agencyModule from './modules/agency-module'
import whitelabelModule from './modules/whitelabel-module'
import landingModule from './modules/landing-module'
import podcastModule from './modules/podcast-module'
import templateModule from './modules/template-module'
import courseModule from './modules/course-module'
import imageModule from './modules/image-module'
import blogModule from './modules/blog-module'
import blockModule from './modules/block-module'
import placeModule from './modules/place-module'
import youtubueModule from './modules/youtube-module'
import utilityModule from './modules/utility-module'
import integrationModule from './modules/integration-module'
import gatewayModule from './modules/gateway-module'
import orderModule from './modules/order-module'
import userModule from './modules/user-module'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: false,
  modules: {
    app: appModule,
    auth: authModule,
    paymentMethod: paymentMethodModule,
    subscription: subscriptionModule,
    agency: agencyModule,
    whitelabel: whitelabelModule,
    landing: landingModule,
    podcast: podcastModule,
    template: templateModule,
    course: courseModule,
    image: imageModule,
    blog: blogModule,
    block: blockModule,
    utility: utilityModule,
    place: placeModule,
    youtube: youtubueModule,
    integration: integrationModule,
    gateway: gatewayModule,
    order: orderModule,
    user: userModule
  }
})

export default store